@let profile = profile$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="{{defaultBackHref}}/profile/{{profileId}}"></ion-back-button>
    </ion-buttons>
    <ion-title>Sale Information</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>Sale History</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col size="6" class="tw:border-r-solid tw:border-r tw:border-gray-200">
            <div class="tw:pt-2 tw:text-sm">Median Price:</div>
            <div class="tw:text-lg tw:font-bold">{{profile?.AreaSales?.MedianValue | redCurrency}}</div>
          </ion-col>
          <ion-col size="6" class="tw:flex tw:flex-col tw:items-end">
            <div class="tw:pt-2 tw:text-sm">Highest Sale Price:</div>
            <div class="tw:text-lg tw:font-bold">
              {{profile?.AreaSales?.PriceRangeMax | redCurrency}}
              <ion-icon name="caret-up-outline" color="success"></ion-icon>
            </div>
            <div class="tw:pt-2 tw:text-sm">Lowest Sale Price:</div>
            <div class="tw:text-lg tw:font-bold">
              {{profile?.AreaSales?.PriceRangeMin | redCurrency}}
              <ion-icon name="caret-down-outline" color="danger"></ion-icon>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-grid class="ion-no-padding tw:mt-4">
        <ion-row>
          <ion-col size="6" class="tw:border-r-solid tw:border-r tw:border-gray-200">
            <div class="tw:pt-2 tw:text-sm">Median Price per Sq Ft:</div>
            <div class="tw:text-lg tw:font-bold">{{profile?.AreaSales?.MedianPricePerSqFt | redCurrency}}</div>
          </ion-col>
          <ion-col size="6" class="tw:flex tw:flex-col tw:items-end">
            <div class="tw:pt-2 tw:text-sm">Highest for Sq Ft:</div>
            <div class="tw:text-lg tw:font-bold">
              {{profile?.AreaSales?.MaxPricePerSqFt | redCurrency}}
              <ion-icon name="caret-up-outline" color="success"></ion-icon>
            </div>
            <div class="tw:pt-2 tw:text-sm">Lowest for Sq Ft:</div>

            <div class="tw:text-lg tw:font-bold">
              {{profile?.AreaSales?.MinPricePerSqFt | redCurrency}}
              <ion-icon name="caret-down-outline" color="danger"></ion-icon>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>Neighborhood Snapshot</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col size="6" class="tw:border-r-solid tw:border-r tw:border-gray-200">
            <div class="tw:text-sm">Median FSF:</div>
            <div class="tw:text-lg tw:font-bold">{{profile?.AreaSales?.MedianLivingArea | redSurface}}</div>
          </ion-col>
          <ion-col size="6" class="tw:flex tw:justify-end">
            <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
              <ion-icon src="/assets/svg/bedroom.svg" size="large"></ion-icon>
              <div>{{profile?.AreaSales?.MedianNumBeds | redDashIfEmpty}} Bed</div>
            </div>
            <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
              <ion-icon src="/assets/svg/bathroom.svg" size="large"></ion-icon>
              <div>{{profile?.AreaSales?.MedianNumBaths | redDashIfEmpty}} BA</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item
      [detail]="(profile?.ComparableSales ?? []).length > 0"
      routerLink="{{defaultBackHref}}/profile/{{profileId}}/comparable-sales"
      [disabled]="!profile?.ComparableSales?.length"
    >
      <ion-icon slot="start" src="/assets/svg/comparable-sales.svg"></ion-icon>
      <ion-label>Comparable Sales</ion-label>
      @if (profile?.ComparableSales?.length) {
      <ion-note slot="end">{{profile?.ComparableSales?.length}}</ion-note>
      } @if (!profile?.ComparableSales?.length) {
      <ion-badge slot="end">Unavailable</ion-badge>
      }
    </ion-item>
  </ion-list>
</red-page-content>
